import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import copy from 'copy-to-clipboard';
import { FormControl, TextField, Select, MenuItem, Tooltip, IconButton } from '@mui/material';
import Trash from '../../../../assets/trashGreyDark.svg';
import CopyIcon from '../../../../assets/copyIcon.svg';
import { MailsList } from '../MailsList';

const MailItem = ({ index, currentAddress, domains, remove, setMailsList, ...props }) => {
	const { t } = useTranslation();
	const [mailValue, setMailValue] = useState('');
	const [domainValue, setDomainValue] = useState('');
	const loginInputRef = useRef();
	const domainValueRef = useRef();

	useEffect(() => {
		if (!currentAddress) {
			const defaultDomain = domains.find(domain => domain.is_default)?.name;
			setDomainValue(defaultDomain);
			domainValueRef.current = defaultDomain;
		} else {
			const parts = currentAddress.split('@');
			setMailValue(parts[0]);
			setDomainValue(parts[1]);
			domainValueRef.current = parts[1];
		}
	}, [currentAddress, domains]);

	const setMailsListHandler = index => {
		setMailValue(loginInputRef.current.value);
		setMailsList(prev => {
			prev[index] = `${loginInputRef.current.value}@${domainValueRef.current}`;

			return [...prev];
		});
	};

	const setDomainValueHandler = e => {
		setDomainValue(e.target.value);
		domainValueRef.current = e.target.value;
	};

	return (
		<div className='mail-item' {...props}>
			<TextField
				inputRef={loginInputRef}
				variant='standard'
				fullWidth
				placeholder={t('additionalEmails.add_mail')}
				value={mailValue}
				onChange={e => {
					setMailsListHandler(index);
				}}
			/>
			@
			<FormControl variant='standard' fullWidth>
				<Select
					value={domainValue}
					onChange={e => {
						setDomainValueHandler(e);
						setMailsListHandler(index);
					}}
				>
					{domains.map((domain, index) => {
						return (
							<MenuItem key={`domain-${index}`} value={domain.name}>
								{domain.name}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
			<Tooltip title={t('additionalEmails.copy')}>
				<IconButton
					aria-label='Copy mail'
					onClick={e => {
						copy(`${loginInputRef.current.value}@${domainValueRef.current}`);
					}}
					className='round-tooltip'
				>
					<img src={CopyIcon} alt={CopyIcon} />
				</IconButton>
			</Tooltip>
			<Tooltip title={t('additionalEmails.remove')}>
				<IconButton
					aria-label='Remove mail'
					onClick={e => {
						remove(index);
					}}
					className='round-tooltip'
				>
					<img src={Trash} alt={Trash} />
				</IconButton>
			</Tooltip>
		</div>
	);
};

export const HomePostalAddresses = ({ defaultMails, domains, setStateCallback }) => {
	const { t } = useTranslation();
	const [mailsList, setMailsList] = useState(defaultMails || []);

	useEffect(() => {
		setStateCallback(mailsList);
	}, [mailsList]);

	const addHomePostalAddressHandler = () => {
		setMailsList(prev => [...prev, '']);
	};

	const removeHomePostalAddressHandler = index => {
		setMailsList(prev => {
			const prevMailsList = [...prev];
			prevMailsList.splice(index, 1);

			return prevMailsList;
		});
	};

	return (
		<MailsList title={t('additionalEmails.title')} addMail={addHomePostalAddressHandler} className='home-postal-addresses'>
			{mailsList?.map((mail, index) => (
				<MailItem key={`home-postal-${index}`} index={index} currentAddress={mail} remove={removeHomePostalAddressHandler} setMailsList={setMailsList} domains={domains} />
			))}
		</MailsList>
	);
};
